import { Box } from 'ui'
import { PendingInvites } from './PendingInvites'
import { CompanyMembers } from './CompanyMembers'

export function Team() {
  return (
    <Box>
      <PendingInvites />
      <CompanyMembers />
    </Box>
  )
}
